module.exports = __webpack_public_path__ + "static/icon-columns-3bd4fe0f61ac56c09360a14927e20558.svg";